import React from 'react';

export default function UrjanetView() {
  return (
    <div data-cy="urjanetconnect">
      Urjanet Connect will go here.
    </div>
  );
}
